import cn from 'classnames';
import {
    type AnnouncementBannerProps,
    AnnouncementBanner,
} from '@/ui-components/molecules/AnnouncementBanner/AnnouncementBanner';
import styles from './announcementbannergroup.module.scss';

export interface AnnouncementBannerGroupProps {
    banners: AnnouncementBannerProps[];
    borderColorSet: AnnouncementBannerProps['colorSet'];
}

export function AnnouncementBannerGroup({
    banners = [],
    borderColorSet = 'base',
}: AnnouncementBannerGroupProps): React.JSX.Element {
    return (
        <div className={styles.wrapper}>
            {banners.map((banner, index) => (
                <div
                    className={cn(
                        styles.bannerWrapper,
                        styles[`colorSet-${banner.colorSet ?? borderColorSet}`],
                    )}
                    key={index}
                >
                    <AnnouncementBanner {...banner} />
                </div>
            ))}
        </div>
    );
}
